/**
 * Labstep
 *
 * @module components/AccessKey/Action/Create
 * @desc Create action for Access Key
 */

import { AccessKeyFormCreate } from 'labstep-web/components/AccessKey/Form/Create';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { AccessKey } from 'labstep-web/models/access-key.model';
import type React from 'react';

const createText = `Add ${AccessKey.getHumanReadableEntityName()}`;

export const AccessKeyActionCreate: React.FC = () => (
  <ModalDefault
    header={createText}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        onClick={toggleModal}
        text={createText}
        type="text"
        icon={ICONS.access_key.primary}
      />
    )}
    content={({ toggleModal }) => (
      <AccessKeyFormCreate options={{ onSuccess: toggleModal }} />
    )}
  />
);
